import { createLogger } from '@/lib/logger';
import { ProductsCarousel } from './products-carousel';

function switchRoutine(tabHandle: string) {
  // Set clicked tab to active
  const routineButtons = document.querySelectorAll<HTMLButtonElement>('.shop-by-routine--tab');
  routineButtons.forEach((button) => {
    button.classList.toggle('active', button.getAttribute('data-tab') === tabHandle);
  });

  // Set corresponding tab content to active
  const tabContentElems = document.querySelectorAll('.shop-by-routine--tab-content');
  tabContentElems.forEach((tabContentElem) => {
    tabContentElem.classList.toggle(
      'active',
      tabContentElem.getAttribute('data-tab') === tabHandle,
    );
  });

  ProductsCarousel.switchVisibleNavigation('shop-by-routine', tabHandle);
}

document.addEventListener('DOMContentLoaded', () => {
  const log = createLogger('shop-by-routine');
  const tabsSwiperElem = document.querySelector('.shop-by-routine--tabs');

  if (!tabsSwiperElem) {
    log.error('tabsSwiperElem not found');
    return;
  }

  const tabsSwiper = new window.Swiper('.shop-by-routine--tabs', {
    slidesPerView: 'auto',
    spaceBetween: 0,
    freeMode: true,
    direction: 'horizontal',
    breakpoints: {
      768: {
        direction: 'vertical',
      },
    },
  });

  const routineButtons = document.querySelectorAll<HTMLButtonElement>('.shop-by-routine--tab');

  routineButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (document.startViewTransition) {
        document.startViewTransition(() => switchRoutine(button.getAttribute('data-tab')!));
      } else {
        switchRoutine(button.getAttribute('data-tab')!);
      }
    });
  });
});
